module.exports = __webpack_public_path__ + "img/droplet-half.b6c1fe6e.svg";